import Vue from 'vue';
import Vuex from 'vuex';
import { event } from 'vue-analytics';

// Google Analytics ID is configured in main.ts

Vue.use(Vuex);

export default {
    state: {
    },
    mutations: {
    },
    actions: {
        sendListingEvent(context: any, payload: any) {
            event({
                eventCategory: 'Listing',
                eventAction: payload.action,
                eventLabel: payload.sysId,
                // eventValue:
            });
        },
        sendBasemapEvent(context: any, payload: any) {
            event({
                eventCategory: 'Basemap',
                eventAction: payload.action,
                // eventLabel:
                // eventValue:
            });
        },
        sendOpsLayerEvent(context: any, payload: any) {
            event({
                eventCategory: 'OpsLayer',
                eventAction: payload.action,
                // eventLabel:
                // eventValue:
            });
        },
        sendWalkabilityEvent(context: any, payload: any) {
            event({
                eventCategory: 'Walkability',
                eventAction: payload.sysId,
                // eventLabel:
                // eventValue:
            });
        },
        sendFilterEvent(context: any, payload: any) {
            event({
                eventCategory: 'Filter',
                eventAction: payload.filter,
                // eventLabel:
                // eventValue:
            });
        },
        sendDetailsEvent(context: any, payload: any) {
            event({
                eventCategory: 'InDetails',
                eventAction: payload.action,
                eventLabel: payload.sysId,
                // eventValue:
            });
        },
    },
};
